<template>
  <v-footer
    fixed
    app
    inset
    :height="theme.footer_height"
    :color="theme.footer_bg_color"
  >
    <template v-if="isMember">
      <v-btn
        v-if="allowCheckout.all"
        block
        :dark="!btn.disabled"
        large
        class="btn"
        :color="theme.btn_color_secondary"
        :disabled="btn.disabled"
        @click="payment"
      >
        <v-layout row>
          <v-flex
            xs12
            class="text-xs-center nowrap-text"
          >
            {{ btn.text }}
          </v-flex>
        </v-layout>
      </v-btn>
    </template>
    <template v-else>
      <v-btn
        v-if="allowLogin"
        block
        dark
        large
        class="btn pl-0 pr-0 text-xs-center"
        :color="theme.btn_color_secondary"
        @click="register"
      >
        <v-layout row>
          <v-flex
            xs12
            class="text-xs-center nowrap-text"
          >
            {{ registerBtn }}
          </v-flex>
        </v-layout>
      </v-btn>
      <v-btn
        v-if="allowCheckout.guest"
        block
        :dark="!btn.disabled"
        large
        class="btn pl-0 pr-0 text-xs-center"
        :color="theme.btn_color_secondary"
        :disabled="btn.disabled"
        @click="payment"
      >
        <v-layout row>
          <v-flex
            xs12
            class="text-xs-center nowrap-text"
          >
            {{ btn.text }}
          </v-flex>
        </v-layout>
      </v-btn>
    </template>
    <template>
      <form
        v-for="(p, index) in paymentModes"
        :key="index"
        :id="'payment-form-' + p.code"
        :action="(env !== 'production' || parseInt(gid) === 21) ? paymentTypes[p.code].dev : paymentTypes[p.code].prod"
        :custom-code="p.code"
        method="post"
      >
        <input
          type="hidden"
          name="member_id"
          :value="memberId"
        />
        <input
          type="hidden"
          name="loyalty_group_id"
          :value="loyaltyGroupId"
        />
        <input
          type="hidden"
          name="platform_id"
          :value="posType === 0 ? 3 : 4"
        />
        <input
          type="hidden"
          name="platform_transaction_id"
          :value="activeOrder.reference_id"
        />
        <input
          type="hidden"
          name="is_guest"
          :value="isGuest"
        />
        <input
          type="hidden"
          name="reference_id"
          :value="activeOrder.reference_id"
        />
        <input
          type="hidden"
          name="transaction_amount"
          :value="activeOrder.payments_topay"
        />
        <input
          type="hidden"
          name="restaurant_id"
          :value="rid"
        />
        <input
          type="hidden"
          name="account"
          :value="epayAccount"
        />
        <input
          type="hidden"
          name="payment_mode"
          :value="paymentTypes[p.code].mode"
        />
        <input
          type="hidden"
          name="payment_time"
          value="payBeforeServe"
        />
        <input
          type="hidden"
          name="redirect_url"
          :value="returnUrl"
        />
        <input
          type="hidden"
          name="hash"
          :value="hash"
        />
      </form>
    </template>
  </v-footer>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { checkAvailableSchema } from '../store/modules/menu'
import Cookies from 'js-cookie'
import apple_pay from '../mixins/apple_pay'
import Form from 'vform'

export default {
  data: () => ({
    hash: null
  }),
  mixins: [apple_pay],
  computed: {
    ...mapGetters('config', [
      'theme', 'redirectUrl', 'paymentTypes', 'paymentModes', 'guestId', 'epayAccount',
      'gid', 'rid', 'mode', 'restaurants', 'posType', 'loyaltyGroupId', 'allowCheckout',
      'allowLogin', 'enableMemberPoints', 'holidays'
    ]),
    ...mapGetters('member', [
      'points', 'profile', 'isMember'
    ]),
    ...mapGetters('auth', [
      'user', 'authenticated'
    ]),
    ...mapGetters('menu', [
      'catListIds'
    ]),
    ...mapGetters('order', [
      'paymentMode', 'activeOrder', 'usePoints', 'useCredit', 'orderMsg', 'activeOrderPayments'
    ]),
    ...mapGetters('cart', [
      'cart', 'cartQty', 'pickupDate', 'pickupTime', 'cartMsg', 'times', 'guestDetailsStatus'
    ]),
    env () {
      return process.env.NODE_ENV
    },
    registerBtn () {
      if (this.enableMemberPoints) {
        return this.$t('signup_earn_points')
      }
      return this.$t('signup')
    },
    btn () {
      if (this.paymentMode) {
        const text = this.isMember ? this.$t('member_checkout') : this.$t('guest_checkout') // this.$t('pay_by') + this.$t(this.paymentTypes[this.paymentMode.code].title)
        return {
          disabled: false,
          text: text
        }
      }
      return {
        disabled: true,
        text: this.$t('select_payment_mode')
      }
    },
    isGuest () {
      return (this.isMember) ? 0 : 1
    },
    memberId () {
      if (this.isMember) {
        return this.profile.loyalty_member_id
      }
      return 0 // this.guestId
    },
    returnUrl () {
      return this.redirectUrl.payBeforeServe
    }
  },
  methods: {
    async logPaymentData () {
      try {
        let content = {
          ...this.activeOrder,
          loyalty_group_id: document.getElementsByName('loyalty_group_id')[0].value,
          platform_id: document.getElementsByName('platform_id')[0].value,
          platform_transaction_id: document.getElementsByName('platform_transaction_id')[0].value,
          is_guest: document.getElementsByName('is_guest')[0].value,
          reference_id: document.getElementsByName('reference_id')[0].value,
          transaction_amount: document.getElementsByName('transaction_amount')[0].value,
          restaurant_id: document.getElementsByName('restaurant_id')[0].value,
          account: document.getElementsByName('account')[0].value,
          payment_mode: document.getElementsByName('payment_mode')[0].value,
          payment_time: document.getElementsByName('payment_time')[0].value,
          redirect_url: document.getElementsByName('redirect_url')[0].value,
          hash: document.getElementsByName('hash')[0].value
        }
        if (this.isMember) {
          content.member = this.profile
        }
        await axios.post('/api/log', {
          action: 'directToEPay',
          content: content
        })
      } catch (e) { }
    },
    register () {
      if (this.authenticated) {
        this.$router.push({ name: 'register2' })
      } else {
        this.$router.push({ name: 'register' })
      }
    },
    async payment () {
      if (this.rInfoExpiredAlert()) {
        return
      } else if (this.noTableOrAddressAlert()) {
        return
      }
      const prefix = window.config.prefix;
     if(Cookies.get(`${prefix}rid`) == '963') {

       if (!this.checkCart()) {//检测菜品还可以下单
         await this.$store.dispatch('responseMessage', {
           type: 'error',
           text: 'Session Expired',
           noBtn: this.$mq === 'sm' || this.$mq === 'md' || this.$mq === 'lg' || this.$mq === 'xl'
         })
         setTimeout(async () => {
           await this.$store.dispatch('resetAppRelatedData')
           await this.$store.dispatch('config/resetModeSelected')
           if (this.isMember) {
             await this.$store.dispatch('fetchMembershipInfo')
           }
           await this.$router.push({ name: 'welcome' })
         }, 1000);
       }
     }else {
       if (this.shouldExpireSession()) {
         await this.$store.dispatch('responseMessage', {
           type: 'error',
           text: 'Session Expired',
           noBtn: this.$mq === 'sm' || this.$mq === 'md' || this.$mq === 'lg' || this.$mq === 'xl'
         })
         setTimeout(async () => {
         await this.$store.dispatch('resetAppRelatedData')
         await this.$store.dispatch('config/resetModeSelected')
         if (this.isMember) {
           await this.$store.dispatch('fetchMembershipInfo')
         }
         await this.$router.push({ name: 'welcome' })
         }, 1000);
       }
     }
      // This function might takes long to load, so add a loading indicator
      this.$bus.$emit('showFullLoading', true)

      // Check pickup date and time
      if (this.mode.isTakeaway || this.mode.isDelivery) {
        if (!this.isMember && this.guestDetailsStatus.isEmpty) {
          this.$bus.$emit('showFullLoading', false)
          this.$router.push({ name: 'guest_details' })
          return
        }
        await this.$store.dispatch('cart/fetchTakeawayTimes', this.pickupDate)
        const time = this.times.find(t => t.time === this.pickupTime && t.availTime > 0)
        if (!time) {
          this.$bus.$emit('showFullLoading', false)
          this.$store.dispatch('cart/resetPickupDateTime')
          this.$store.dispatch('responseMessage', {
            type: 'error',
            title: this.$t('invalid_time'),
            text: this.$t('reselect_time'),
            modal: true,
            buttons: [{ text: 'Ok', path: 'cart' }]
          })
          return
        }
      }

      // Check availability schema
      await this.$store.dispatch('menu/fetchMenuCats')

      if(Cookies.get(`${prefix}rid`) != '963') {
        if (!this.checkCart()) {
          return;
        }
      }
      /**
      for (const item of this.cart) {
          const currentMode = this.mode
          const date = currentMode.isTakeaway || currentMode.isDelivery ? this.pickupDate : null
          const time = currentMode.isTakeaway || currentMode.isDelivery ? this.pickupTime : null
          const selectedDateTime = date && time ? date + ' ' + time : null
          const timeData = await axios.post('/api/moment/current', {
            holidays: this.holidays,
            date: selectedDateTime
          })
          const currentTime = timeData.data
          await axios.post('/api/menu/cat/items', {
            restaurant_id: parseInt(this.rid),
            category_id: item.category_id,
            date: date,
            time: time
          }).then(response => {
            if (!response.data.find(i => i.item_id === item.item_id)) {
              notAvailableItems.push(item.name)
            } else {
              let c = response.data.find(i => i.item_id === item.item_id)
              if (checkAvailableSchema(c.avail_schema, currentTime) !== 0) {
                notAvailableItems.push(item.name)
              }
            }
          })
      }

      if (notAvailableItems.length > 0) {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: this.$t('item_unavailable'),
          text: 'The following item(s) is unavailable:' + notAvailableItems.join(', '),
          modal: true
        })
        this.$bus.$emit('showFullLoading', false)
        return
      }
       **/

      await this.$store.dispatch('cart/checkCartItems')
      if (this.cartMsg) {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: 'Unable to submit',
          text: this.cartMsg,
          modal: true
        })
        this.$bus.$emit('showFullLoading', false)
        return
      }

      await this.$store.dispatch('cart/checkCartDiscountInfo')
      if (this.cartMsg) {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: 'Unable to submit',
          text: this.cartMsg,
          modal: true
        })
        this.$bus.$emit('showFullLoading', false)
        return
      }

      if (this.posType === 0) {
        await this.$store.dispatch('order/checkFinalOrder', this.activeOrderPayments)
      } else {
        await this.$store.dispatch('order/checkFinalOrder2', this.activeOrderPayments)
      }

      if (this.orderMsg) {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: 'Unable to submit',
          text: this.orderMsg,
          modal: true
        })
        this.$bus.$emit('showFullLoading', false)
        return
      }

      // Get hash from server
      const { data } = await axios.post('/api/epay/md5', {
        guest_id: 0, // this.guestId
        loyalty_group_id: this.loyaltyGroupId,
        restaurant_id: this.rid,
        transaction: this.activeOrder,
        type: 'payBeforeServe'
      })
      this.hash = data

      // Wait for 1 second before submitting since the form input is not set immediately
      setTimeout(async () => {
        // Prevent submit if platformTransactionId/hash is 0 or null
        const formPlatformTransactionId = document.getElementsByName('platform_transaction_id')[0].value
        const formReferenceId = document.getElementsByName('reference_id')[0].value
        const formHash = document.getElementsByName('hash')[0].value
        if (!this.activeOrder || !formPlatformTransactionId || !formReferenceId || !formHash || formPlatformTransactionId == 0 || formReferenceId == 0) {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            title: 'Unable to checkout',
            text: 'Failed to check order from server. Please try again',
            modal: true
          })
          this.$bus.$emit('showFullLoading', false)
          return
        }

        await this.$store.dispatch('order/saveActiveOrderEpayClientRef')
        this.$bus.$emit('showFullLoading', false)
        if (this.orderMsg) {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            title: 'Unable to submit',
            text: this.orderMsg,
            modal: true
          })
          return
        }

        this.logPaymentData()

        if (this.paymentMode.code === 'apple_pay') {
          console.log('in PaymentFooter.vue this.paymentMode.code === \'apple_pay\'')
          console.log(formPlatformTransactionId)
          // let form = new Form(document.getElementById('payment-form-' + this.paymentMode.code))
          let formData = new FormData(document.getElementById('payment-form-' + this.paymentMode.code))
          let ePayData = Object.fromEntries(formData);

          console.log('Payment Function In PaymentFooter.vue')
          console.log(this.activeOrder)
          console.log(ePayData)
          console.log('Payment Function In PaymentFooter.vue')

          this.applePayStart(this.activeOrder, ePayData);

          return;
        } else {
          document.getElementById('payment-form-' + this.paymentMode.code).submit()
        }
      }, 1000)
    },
    async checkCart(){
      const notAvailableItems = []
      this.cart.forEach(item => {
        if (!item.is_promo && !this.catListIds.includes(item.category_id) && !item.member_voucher_id) {
          if (!item.is_auto_preset) notAvailableItems.push(item.name)
        }
      })
      for (const item of this.cart) {
        const currentMode = this.mode
        const date = currentMode.isTakeaway || currentMode.isDelivery ? this.pickupDate : null
        const time = currentMode.isTakeaway || currentMode.isDelivery ? this.pickupTime : null
        const selectedDateTime = date && time ? date + ' ' + time : null
        const timeData = await axios.post('/api/moment/current', {
          holidays: this.holidays,
          date: selectedDateTime
        })
        const currentTime = timeData.data
        await axios.post('/api/menu/cat/items', {
          restaurant_id: parseInt(this.rid),
          category_id: item.category_id,
          date: date,
          time: time
        }).then(response => {
          if (!response.data.find(i => i.item_id === item.item_id)) {
            notAvailableItems.push(item.name)
          } else {
            let c = response.data.find(i => i.item_id === item.item_id)
            if (checkAvailableSchema(c.avail_schema, currentTime) !== 0) {
              notAvailableItems.push(item.name)
            }
          }
        })
      }

      if (notAvailableItems.length > 0) {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: this.$t('item_unavailable'),
          text: 'The following item(s) is unavailable:' + notAvailableItems.join(', '),
          modal: true
        })
        this.$bus.$emit('showFullLoading', false)
        return false;
      }
      return true;
    },
  },
}
</script>

<style scoped>
.btn {
  margin: 10px;
}
.nowrap-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/PaymentFooter.vue